import { PRODUCT } from "@/constants";

const classNames = {
  avanti: {
    toggleBtnText: " text-text-title ",
  },
  staysure: {
    toggleBtnText: " text-functional ",
  },
};

const brand: "staysure" | "avanti" =
  (PRODUCT as "staysure" | "avanti") ?? "staysure";

const brandClassNames = classNames[brand];

export default brandClassNames;
